var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderSkinSocketVertical(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "placeholder_skin_socket_vertical") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "placeholder_skin_socket_vertical",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    fill: "#FFA367",
    x: 19,
    y: 2.5,
    width: 62,
    height: 95,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(37.000000, 39.500000)",
    stroke: "#979797",
    strokeLinecap: "square",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 5.625,
    y1: 0.35,
    x2: 0.375,
    y2: 6.65,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.625,
    y1: 0.35,
    x2: 20.375,
    y2: 6.65,
    id: "Line-Copy",
    transform: "translate(23.000000, 3.500000) scale(-1, 1) translate(-23.000000, -3.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 14.5,
    x2: 12.5,
    y2: 23.5,
    id: "Line-Copy-2",
    transform: "translate(12.500000, 19.000000) scale(-1, 1) translate(-12.500000, -19.000000) "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.7113821,85 L70.7113821,83.8239845 C70.803523,83.205029 71.0281165,82.6892328 71.3851626,82.2765957 C71.7422087,81.8639587 72.151084,81.4977434 72.6117886,81.1779497 C73.0724932,80.858156 73.5619919,80.5383623 74.0802846,80.2185687 C74.5985772,79.898775 75.0707995,79.5119278 75.4969512,79.0580271 C75.923103,78.6041264 76.2801491,78.0573823 76.5680894,77.417795 C76.8560298,76.7782076 77,75.9632495 77,74.9729207 C77,74.374597 76.8560298,73.7298517 76.5680894,73.0386847 C76.2801491,72.3475177 75.802168,71.7027724 75.1341463,71.1044487 C74.4661247,70.5061251 73.5850271,70.0058027 72.4908537,69.6034816 C71.3966802,69.2011605 70.0318428,69 68.3963415,69 C67.1294038,69 65.9834011,69.1908446 64.9583333,69.5725338 C63.9332656,69.9542231 63.0579268,70.4854932 62.3323171,71.1663443 C61.6067073,71.8471954 61.0423442,72.6518375 60.6392276,73.5802708 C60.2361111,74.5087041 60.0230352,75.5299807 60,76.6441006 L65.0792683,76.6441006 C65.0792683,76.0870406 65.148374,75.5660864 65.2865854,75.0812379 C65.4247967,74.5963894 65.6378726,74.1734365 65.925813,73.8123791 C66.2137534,73.4513217 66.5823171,73.1624758 67.0315041,72.9458414 C67.4806911,72.729207 68.0162602,72.6208897 68.6382114,72.6208897 C69.5596206,72.6208897 70.2794715,72.8478401 70.7977642,73.3017408 C71.3160569,73.7556415 71.5752033,74.4571244 71.5752033,75.4061896 C71.5982385,75.9632495 71.4888211,76.4274662 71.2469512,76.7988395 C71.0050813,77.1702128 70.6883469,77.5106383 70.296748,77.8201161 C69.9051491,78.1295938 69.4789973,78.4390716 69.0182927,78.7485493 C68.5575881,79.0580271 68.1199187,79.4242424 67.7052846,79.8471954 C67.2906504,80.2701483 66.9278455,80.7807866 66.6168699,81.3791103 C66.3058943,81.9774339 66.1158537,82.7201805 66.046748,83.6073501 L66.046748,85 L70.7113821,85 Z M71,93 L71,87 L66,87 L66,93 L71,93 Z",
    id: "?",
    fillOpacity: 0.221345061,
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderSkinSocketVertical);
export default __webpack_public_path__ + "static/media/placeholder_skin_socket_vertical.7d42ce29cea42a3865dbaa7a6e39b1ee.svg";
export { ForwardRef as ReactComponent };